import * as React from 'react'
// components
import { HoverablePopover, Table } from 'components/UI'
import TableRow from '@mui/material/TableRow'
import UpdateReportsModal from 'components/Modals/UpdateReportsModal/index'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
import { PowerBIReportsAPIContext } from 'containers/PowerBIReports/layers/API'
// constants
import { Modals } from 'constants/index'
// hooks
import { useShowModal } from 'hooks'
// themes
import { EllipsizedText } from 'themes/views/generic'
// views
import { TableCell, TEXT_STYLE } from 'themes/views/tables'

const headers = [
  { id: 'report.name', sortable: false, left: true, label: 'NAME' },
  { id: 'report.id', sortable: false, left: true, label: 'ID' }
]

const ReportsTable: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, totalCount, refetch, isRefetching } = React.useContext(PowerBIReportsAPIContext)

  const { showModal } = useShowModal({ modalType: Modals.REPORT_UPDATE_MODAL })

  const showUpdateModal = () => showModal()

  return (
    <>
      <Table
        data={data}
        page={page}
        title='Reports'
        headers={headers}
        perPage={perPage}
        refetch={refetch}
        totalCount={totalCount}
        isLoading={isRefetching}
        onPageChange={handleSetPage}
        onPerPageChange={handleSetPerPage}>
        {({ data }) =>
          data.map(({ id, name }) => (
            <TableRow key={id} hover>
              <TableCell size={25} style={TEXT_STYLE}>
                <HoverablePopover
                  trigger={
                    <EllipsizedText onClick={showUpdateModal} style={TEXT_STYLE}>
                      {name}
                    </EllipsizedText>
                  }>
                  {name}
                </HoverablePopover>
              </TableCell>
              <TableCell size={35}>{id}</TableCell>
            </TableRow>
          ))
        }
      </Table>

      <UpdateReportsModal />
    </>
  )
}

export default ReportsTable
